module.exports = __webpack_public_path__ + "static/media/activo.71a65636.svg";